import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  borderRadius: theme.border.radius['8'],
  boxShadow: theme.shadow.sm,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
  padding: `${theme.space['12']}`,
  width: '26rem',
}))

export const Header = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const Logo = styled.img(() => ({
  height: '1.6rem',
  objectFit: 'contain',
}))

export const Link = styled.a(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.2rem',
  fontWeight: 500,
  textDecoration: 'underline',
  width: 'fit-content',
}))
